import React from 'react'
import DotMap from '../DotMap'
import DotInfoBox from '../DotInfoBox'
import LineTo from '../DrawLine'
import './DotSelect.css'

class DotSelect extends React.Component {
  constructor() {
    super()
    this.state = {
      // - 1 means no dropdown is open, otherwise it's the index of the dropdown that's been opened
      selected: -1,
      showLine: false,
    }
  }

  componentDidMount() {
    document
      .getElementById('VenusQuizApplication')
      .addEventListener('click', e => this.onScreenClick(e))
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.selected !== prevState.selected) {
      this.setState({ showLine: true })
    }
  }

  componentWillUnmount() {
    document
      .getElementById('VenusQuizApplication')
      .removeEventListener('click', e => this.onScreenClick(e))
  }

  onScreenClick(e) {
    if (!this.childOf('infoBox', e.target)) {
      this.setState({ selected: -1 })
    }
  }

  childOf(id, target) {
    var tar = target
    var timeoutCount = 0
    while (tar.parentNode && timeoutCount < 10) {
      if (tar.id === id) {
        return true
      }
      tar = tar.parentNode
      timeoutCount++
    }
    return false
  }

  static defaultProps = {
    width: 1200,
    height: 661,
    dotProps: {
      image:
        'https://www.holsterfashion.co.za/wp-content/themes/claue/assets/images/placeholder.png',
      //Dot locations are specified [down px, right px] from the top left of the IMAGE
      locations: [[50, 50], [100, 370]],
      dotSize: 30,
    },
    boxes: [
      {
        //box locations are specified [down px, right px] from the top left of the DOTSELECT COMPONENT (which has its width/height specified in these props)
        location: [50, 50],
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit',
        title: 'item 1',
        references: "reference"
      },
      {
        location: [100, 900],
        content: 'lorem ipsum dolor sit',
        title: 'item 2',
        //offsetFrom lets the location be specified from the right side (it's top left by default)
        offsetFrom: 'right',
      },
    ],
    toggledBoxes: [],
    onToggle: () => {},
  }

  handleDotSelect(e) {
    this.setState({
      selected: e,
    })
  }

  renderBox(box, index) {
    const { selected, showLine } = this.state
    const { toggledBoxes } = this.props
    const expanded = selected === index
    return (
      <React.Fragment key={index}>
        <div
          style={{ top: box.location[0] + 'px', left: box.location[1] + 'px' }}
          className={'boxWrapper'}
        >
          <DotInfoBox
            {...box}
            isexpanded={expanded}
            onTitleClick={() => this.handleDotSelect(index)}
            onToggle={e => this.props.onToggle(e, index)}
            isToggled={toggledBoxes.includes(index)}
            onClose={() => this.setState({ selected: -1 })}
          />
          <div className={'boxLineHook box' + index} />
        </div>
        {expanded && showLine && (
          <LineTo
            from={'dot' + index}
            to={'box' + index}
            borderColor="#0A71F0"
            zIndex={0}
          />
        )}
      </React.Fragment>
    )
  }

  render() {
    const { width, height, boxes } = this.props
    return (
      <div style={{ width, height }} className={'dotSelect'}>
        <DotMap
          {...this.props.dotProps}
          onDotSelect={e => this.handleDotSelect(e)}
          selected={this.state.selected}
        />
        {boxes.map((box, index) => this.renderBox(box, index))}
      </div>
    )
  }
}

export default DotSelect
